<template>
  <v-menu :offset-x="offsetX" :offset-y="offsetY" left :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn :color="color" large rounded v-bind="attrs" v-on="on">
        Need Help?
      </v-btn>
    </template>
    <v-card>
      <v-card-text style="max-width: 200px">
        <div class="text-h6 font-weight-bold">Need Help?</div>
        <p>If you need assistance you can contact your district admin.</p>
        <!-- <help-block /> -->
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
// import HelpBlock from "./HelpBlock.vue";
export default {
  // components: { HelpBlock },
  name: "HelpMenu",
  props: {
    color: String,
    offsetY: Boolean,
    offsetX: Boolean
  }
};
</script>
